import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import axios from './api/http'
import router from './router'
import store from './store/index'
import VueResource from 'vue-resource';
import YDUI from 'vue-ydui';
import 'vue-ydui/dist/ydui.rem.css';

router.beforeEach((to, from, next) => {
  var sessionUser = sessionStorage.getItem('user');
  if (!sessionUser) {
    axios({
      method: 'get',
      url: "https://mai-zbj-api.ydtg.com.cn/api/action_login",
    }).then(function (response) {
      sessionStorage.setItem('user', JSON.stringify(response.data));
    });
    next()
  } else {
    next()
  }
})
Vue.config.productionTip = false

Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(YDUI);

Vue.prototype.axios = axios;
new Vue({
  el: '#app',
  router, axios, store,
  render: h => h(App)
})





// WEBPACK FOOTER //
// ./src/main.js